import { useMemo } from 'react';
import useGetVehicles from '~/hooks/home/useGetVehicles';
import { AppliedFilters } from '~/services/common/contracts';
import useGetMostViewedOrMostRecentYMM from './useGetMostViewedOrMostRecentYMM';

export default function useGetBudgetFriendlyVehicles() {
  const { make, model, price = 0 } = useGetMostViewedOrMostRecentYMM() ?? {};
  const filters = useMemo<Partial<AppliedFilters>>(
    () =>
      make && model
        ? {
            makes: [{ name: make, models: [{ name: model }] }],
            price: { max: Math.floor(price * 0.9) }
          }
        : {},
    [make, model, price]
  );

  return useGetVehicles(
    filters,
    Boolean(make && model),
    'Budget Friendly Vehicles'
  );
}
